import { render, staticRenderFns } from "./disks.vue?vue&type=template&id=19f86993"
import script from "./disks.vue?vue&type=script&lang=js"
export * from "./disks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports